function init_hall2019init(from_php){
    var main=$(".place.hall2019init");
    var resources={};
    var app;
    var loaderMain = new PIXI.loaders.Loader();
    _moduleEvents.one("moduleClear",function(){
        loaderMain.reset();
        if(typeof app!="undefined" && typeof app.destroy!="undefined" && app!=null){
            app.destroy();
        }
    });
    var girlSpine;
    
    
    $.addToPlacePreloader(function(){
                //on load
    },[],{addToLoader:1});
    
    
    function spineAnim(){
        this.funNames=[
            {wait:"mysli",say:"mysliigada"},
            {wait:"wpadlanapomysl",say:"wpadlanapomylsigada"},
        ];
        var conf={
            img:"girl_spine",
            anim_loop:false,
            anim_name:"mysliigada",
            spineResource:resources,
            onAnimComplete:function(){
                this.playAnim(this.funNames[this.storage.stage][this.storage.state]);
            }
        };
        myPixiElement.spine.call(this,{img:conf.img,spine_conf:conf});
        this.storage={
            stage:0,
            state:"say"
        };
    }
    spineAnim.prototype = Object.create(myPixiElement.spine.prototype);
    spineAnim.prototype=$.extend(spineAnim.prototype,{
        changeState:function(val){
            this.storage.state=val;
            this.playAnim(this.funNames[this.storage.stage][this.storage.state]);
        },
        nextStage:function(){
            if(typeof this.funNames[this.storage.stage+1]!="undefined"){
                this.storage.stage++;
            }
        }
    });
    
    
    
    
    function initSpine(){
    
    
        
    
        loaderMain.add("girl_spine",_IMG_SERV+"/gfx/place/hall2019init/girl/skeleton.json");
    
        loaderMain.load(function (a, r) {
            var i;
            for(i in r){
                resources[i]=r[i];
            }
            
            app= new PIXI.Application({
                width: 1280, height: 780, antialias: true, transparent: true,
                view: main.find("#spineBox canvas")[0]
            });
            girlSpine=new spineAnim();
            app.stage.addChild(girlSpine);
            
            app.ticker.add(
                function(delta){
                    girlSpine.myUpdate(delta);
                }    
            );
            
            $.triggerPlacePreloader(1);
            
            var obj=new myDialogBox(main, main.find("#dialBox"),{
                text_arr:copyArray(from_php.dialog.out),
                length_type:"long",
                user_arr:{
                    user:{name:from_php.login,class_arr:["qright"]},
                    girl:{name:$.takeGirlNameReal(1009)}
                },//
                onEnd:function(){
                    $.goToLocation(from_php.action_end);
                },
                onStartSay:function(type){
                    if(type=="girl"){
                        girlSpine.changeState("say");
                    }
                },
                onEndSay:function(type){
                    if(type=="girl"){
                        girlSpine.changeState("wait");
                    }
                    girlSpine.nextStage();
                },
            });
            obj.init();
            
            
        });
    }
    
    
    
    
            
    initSpine();        
            
    $.handleBottomMenu();    
}